import { reducer as reduxFormReducer } from "redux-form";
import { combineReducers } from "redux";

import { sidebarReducer, themeReducer } from "./containers/Layout/reducers";
import { alert as notificationReducer } from "./containers/Notifications/reducers/alert.reducer";

import {
  viewuser,
  postuser,
  getusers,
  toggleuser,
  editRole,
  getuserrole,
  
} from "./containers/Users/reducers";


 import { domains } from "./containers/Domains/reducers";
 import { getDisbursement, postDisbursement, viewDisbursement, winnerDisbursement, putDisbursement, patchDisbursement } from "./containers/Disbursement/reducers"
 import { getInstitution, postInstitution, viewInstitution } from "./containers/Institution/reducers"
 import { permissions, currentUser,getCurrentUserStatus } from "./containers/CurrentUser/reducers";
 import { roles,getRolesPermissions } from "./containers/Roles/reducers";
 import {getDashBoardDatas,getActiveCampaigns,getSpecificCampaignChart } from "./containers/Dashboard/reducers";
 


export default combineReducers({
  form: reduxFormReducer,
  theme: themeReducer,
  sidebar: sidebarReducer,
  notification: notificationReducer,

  viewuser,
  getusers,
  postuser,
  toggleuser,
  domains,
   permissions,
   currentUser,
   //get user status
   getCurrentUserStatus,
  getuserrole,
  editRole,
  roles,
  getRolesPermissions ,
  getDisbursement,
  postDisbursement,
  putDisbursement,
  patchDisbursement,
  viewDisbursement,
  winnerDisbursement,

  getInstitution,
  postInstitution,
  viewInstitution,
  
 //reducers for dashboard..
 getDashBoardDatas,  
 getActiveCampaigns,
 getSpecificCampaignChart
});
